import React, { useEffect, useRef, useState } from "react"
import { useLocation } from "react-router-dom"
import TabsCustom from "src/components/TabsCustom"
import { WrapperStyle } from "src/pages/ADMIN/HumanResource/styled"
import Button from "src/components/MyButton/Button"
import { StyleTabsCustom } from "src/components/TabsCustom/styled"
import { ToolBarStyle } from "../../../HumanResource/Work/Task/styled"
import WarehouseEntry from "../SimWarehouse/components/WarehouseEntry"
import SvgIcon from "src/components/SvgIcon"
import { Input, Select, DatePicker, message } from "antd"
import ModalCreate from "../SimWarehouse/Modal/ModalCreate"
import { InputSearchStyle } from "../../Setting/common/styled"
import FilterIn from "../SimWarehouse/components/FilterIn"
import STORAGE from "src/lib/storage"
import DataRequest from "../DataProposal"
import ListWarehouseInRequest from "./components/ListWarehouseInRequest"
import ProposalService from "src/services/ProposalService"
import dayjs from "dayjs"

const ListRequest = props => {
  const [activeKey, setActiveKey] = useState("all")
  const [filter, setFilter] = useState({})
  const [excelKeyword, setExcelKeyword] =  useState("")
  const [tabStatus, setTabStatus] = useState("")

  const permissions = localStorage.getItem(STORAGE.PERMISSIONS) || ""
const location = useLocation();
  const { type, statusProposal } = location.state || {};
  console.log(type,statusProposal, "locate");
  const Tabs = {
    all: {
      type: "all",
      name: "Tất cả",
      status: "",
    },
    pending: {
      type: "pending",
      name: "Chờ duyệt",
      status: "1",
    },
    success: {
      type: "success",
      name: "Đã duyệt",
      status: "2",
    },
    // reject: {
    //   type: "reject",
    //   name: "Từ chối",
    //   status: "3",
    // },
  }
  useEffect(() => {
  if (statusProposal) {
    const foundKey = Object.keys(Tabs).find(
      key => Tabs[key].status === statusProposal
    );
    if (foundKey) {
      setActiveKey(foundKey);
      setTabStatus(statusProposal);
    }
  }
}, [statusProposal]);

  const items = Object.keys(Tabs).map(key => ({
    key,
    label: <div className="text-tile-tabs">{Tabs[key].name}</div>,
  }))
  const handleChangeTab = key => {
    setActiveKey(key)
    setTabStatus(Tabs[key].status)
  }

  const handleExportExcel = async () => {
    try {
      const response = await ProposalService.exportProposal({
        supplier_id: filter.supplier_id ?? null,
        created_by: filter.created_by ?? null,
        status: Tabs[activeKey]?.status,
        keyword: excelKeyword,
      })

      if (response) {
        const blob = new Blob([response], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })

        const url = window.URL.createObjectURL(blob)
        const today = dayjs().format("DD-MM-YYYY") // Định dạng ngày

        const link = document.createElement("a")
        link.href = url
        link.setAttribute("download", `Danh_sach_phieu_nhap_kho_${today}.xlsx`)

        document.body.appendChild(link)
        link.click()

        link.remove()
        window.URL.revokeObjectURL(url)
      } else {
        message.error("Không có dữ liệu để xuất Excel.")
      }
    } catch (error) {
      console.error("Lỗi khi xuất Excel:", error)
      message.error("Xuất Excel thất bại.")
    }
  }
  const [shownError, setShownError] = useState(false)

  const hasPermission = permissions.includes("warehouse.propose")

  useEffect(() => {
    if (!hasPermission && !shownError) {
      message.error("Không có quyền truy cập")
      setShownError(true)
    }
  }, [!hasPermission, shownError])

  if (!hasPermission) {
    return null // hoặc <Navigate to="/not-authorized" />
  }

  return (
    <div>
      <WrapperStyle>
        <ToolBarStyle>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: 4,
              marginBottom: 20,
              flexWrap: "wrap",
              gap: 8,
            }}
          >
            <h3
              style={{
                fontSize: "24px",
                fontWeight: "bold",
                color: "#005F90",
                margin: 0,
              }}
            >
              DANH SÁCH PHIẾU NHẬP KHO
            </h3>
          </div>
          <div className="right-side">
            {permissions.includes("warehouse.propose.export") ? (
              <Button btnType="primary1" onClick={handleExportExcel}>
                Xuất Excel
              </Button>
            ) : (
              <React.Fragment />
            )}
          </div>
          <div style={{ width: "100%", overflowX: "auto" }}>
            <StyleTabsCustom>
              <TabsCustom
                onChange={handleChangeTab}
                activeKey={activeKey}
                items={items}
                defaultActiveKey="all"
                type="card"
                destroyInactiveTabPane={true}
              />
            </StyleTabsCustom>
            <ListWarehouseInRequest
              // type={Tabs[key].type}
              scroll={{ x: true }}
              tabStatus={tabStatus}
              setParentFilter={setFilter}
              permissions={permissions}
              setExcelKeyword={setExcelKeyword}
            />
          </div>
        </ToolBarStyle>
      </WrapperStyle>
    </div>
  )
}

export default ListRequest
